<nav class="navbar navbar-expand navbar-header fixed-top">
    <div class="container-fluid">

        <!-- Sidebar Toggle Button -->
        <button class="btn-hambuger" (click)="toggleSidebar()">
            <i class="bi bi-list"></i>
        </button>

        <div class="navbar-collapse justify-content-between">
            <!-- <div class="running-message-container mx-1" *ngIf="marqueeMessage">
                <div class="image-box-22 pe-2">
                    <i class="bi bi-megaphone-fill speaker-icon"></i>
                </div>
                <div class="message-wrapper" #messageWrapper>
                    <span class="scrolling-text" #scrollingText>
                        {{ marqueeMessage }}
                    </span>
                </div>
            </div> -->
            <ul class="navbar-nav ms-auto">
                <!-- Currency Dropdown -->
                <li *ngIf="showCurrencyDropdown" class="nav-item dropdown align-self-center me-2">
                    <button class="navbar-text dropdown-toggle currency-btn" id="currencyDropdownMenu"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        <img *ngIf="selectedCurrency?.imageUrl" [src]="selectedCurrency.imageUrl"
                            class="currency-icon me-2" />
                    </button>

                    <ul class="dropdown-menu dropdown-menu-end shadow-sm" aria-labelledby="currencyDropdownMenu">
                        <li *ngFor="let currency of currencyList" class="dropdown-item currency-item"
                            (click)="changeCurrency(currency)">
                            <img *ngIf="currency.imageUrl" [src]="currency.imageUrl" class="currency-icon me-2"
                                alt="{{ currency.name }}" />
                            <span>{{ currency.currencyCode }}</span>
                        </li>
                    </ul>
                </li>

                <!-- Language Dropdown -->
                <ng-container *ngIf="this.languageConstant.length > 0">
                    <li class="nav-item dropdown align-self-center me-2">
                        <button class="navbar-text dropdown-toggle lang-btn" id="langDropdownMenu"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-translate"></i>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end shadow-sm" aria-labelledby="langDropdownMenu">
                            <ng-container *ngFor="let lang of this.languageConstant">
                                <li class="dropdown-item lang-item" (click)="changeLanguage(lang.code)">
                                    <img [src]="lang.icon" class="lang-icon me-2" alt="{{lang.code}}" />
                                    <span> {{ lang.displayName }} </span>
                                </li>
                            </ng-container>
                        </ul>
                    </li>
                </ng-container>

                <!-- Profile Dropdown -->
                <li class="nav-item dropdown align-self-center">
                    <a class="nav-link dropdown-toggle profile-btn" href="#" id="profileDropdown" role="button"
                        data-bs-toggle="dropdown">
                        {{ this.userInfo?.name }}
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end shadow-sm" aria-labelledby="profileDropdown">
                        <li *ngIf="webType === webTypeConstant.ADMIN">
                            <button type="button" class="dropdown-item profile-item" (click)="syncAdminMenu()">
                                <i class="bi bi-arrow-repeat me-2"></i> {{ 'header.syncMenu' | translate }}
                            </button>
                        </li>
                        <li>
                            <button type="button" class="dropdown-item profile-item" (click)="logout()">
                                <i class="bi bi-box-arrow-right me-2"></i> {{ 'header.logout' | translate }}
                            </button>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>

<div class="marquee-container" *ngIf="marqueeMessage" data-bs-toggle="modal" data-bs-target="#marqueeModal"
    style="cursor: pointer;">
    <div class="image-box-22 pe-2">
        <i class="bi bi-megaphone-fill speaker-icon"></i>
    </div>
    <div class="message-wrapper flex-grow-1" #messageWrapper>
        <span class="scrolling-text" #scrollingText [ngStyle]="{
            '--start-pos': startPos,
            '--end-pos': endPos,
            'animation-duration': duration + 's'
        }">
            {{ marqueeMessage }}
        </span>
    </div>
</div>

<!-- Modal that shows running message -->
<div class="modal fade" id="marqueeModal" tabindex="-1" aria-labelledby="marqueeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="marqueeModalLabel">{{ 'header.marquee' | translate }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <ol class="ps-3">
                    <li *ngFor="let item of (this.merchantMarqueeList || this.unAgentMarqueeList)" class="mb-3">
                        {{ item.message }}
                    </li>
                </ol>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>